import { t } from '@lingui/macro';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { Offer } from 'components/SummaryCard/SummaryCard.helpers';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { useReviewOffer } from '../ReviewOffer.context';
import styles from './RejectOfferButton.module.css';

export const RejectOfferButton = () => {
  const { trackEvent } = useAmplitude();
  const {
    offerDecision,
    setOfferDecision,
    selectedApplication,
    setSelectedOfferId,
  } = useReviewOffer();

  const numberOfOffers =
    selectedApplication?.formal_offer_sets?.[0]?.formal_offers.length;

  const rejectCTAText =
    numberOfOffers === 1
      ? t`Reject offer`
      : numberOfOffers === 2
        ? t`Reject both`
        : t`Reject all`;

  const handleRejectClick = () => {
    trackEvent(AMPLITUDE_EVENTS.rejectOfferClicked, {
      'CTA text': rejectCTAText,
      'Number of offers': numberOfOffers,
    });

    setSelectedOfferId('');
    setOfferDecision(Offer.REJECT);
  };

  if (offerDecision === Offer.UNDECIDED) {
    return (
      <ButtonLink
        className={styles.rejectButton}
        type="submit"
        onClick={handleRejectClick}
      >
        {rejectCTAText}
      </ButtonLink>
    );
  }

  return null;
};
